import React from "react";

const FujairahPricing = ({ title, description, rows, notes, footnote }) => {
  return (
    <section className="ft-pricing-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        <div
          className="table-responsive"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          <table className="ft-pricing-table">
            <thead>
              <tr>
                <th>Vehicle Type</th>
                <th>Tonnage</th>
                <th>Daily</th>
                <th>Weekly</th>
                <th>Monthly</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  <td>{row.vehicle}</td>
                  <td>{row.tonnage}</td>
                  <td>{row.daily}</td>
                  <td>{row.weekly}</td>
                  <td>{row.monthly}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {notes && notes.length > 0 && (
          <div
            className="ft-pricing-notes"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-once="true"
          >
            {notes.map((note, i) => (
              <p key={i} className="ft-pricing-note">
                <strong>{note.title}</strong> {note.description}
              </p>
            ))}
          </div>
        )}

        {footnote && <p className="ft-pricing-footnote">{footnote}</p>}
      </div>
    </section>
  );
};

export default FujairahPricing;
